module.exports = __webpack_public_path__ + "img/bat_no.7a1591ee.png";